export const FounderIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <title>{"swimming-jump"}</title>
      <path
        d="M23.5,23.5h-13l0-.043c1.492.318,2.712-1.229,2.712-1.229h0a2.805,2.805,0,0,0,2.2,1.251,3.216,3.216,0,0,0,2.387-1.251h0a2.327,2.327,0,0,0,2.017,1.251,2.682,2.682,0,0,0,2.2-1.251h0a2.983,2.983,0,0,0,1.47,1.159Z"
        fill="#00e6ca"
      />
      <path d="M.5,19.5H10a.5.5,0,0,1,.5.5v3.5H.5Z" fill="#c4f0eb" />
      <circle
        cx={18}
        cy={6.15}
        r={2.5}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#c4f0eb"
      />
      <path
        d="M23.5,23.387a2.983,2.983,0,0,1-1.47-1.159h0a2.682,2.682,0,0,1-2.2,1.251,2.327,2.327,0,0,1-2.017-1.251h0a3.216,3.216,0,0,1-2.387,1.251,2.805,2.805,0,0,1-2.2-1.251h0S12,23.775,10.5,23.457"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M.5,19.5H10a.5.5,0,0,1,.5.5v3.5"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.251,17.5l2.364-3.676L3.062,10.169A1.5,1.5,0,0,1,4,7.5H9.753L6.738,2.811A1.5,1.5,0,1,1,9.26,1.188l4.5,7A1.5,1.5,0,0,1,12.5,10.5H8.266l2.28,1.83a1.5,1.5,0,0,1,.323,1.981L8.818,17.5Z"
        fill="#00e6ca"
      />
      <path
        d="M13.4,10.2a1.5,1.5,0,0,0,.365-2.013l-4.5-7A1.5,1.5,0,0,0,7.188.738a1.433,1.433,0,0,0-.126.09Z"
        fill="#c4f0eb"
      />
      <path
        d="M5.251,17.5l2.364-3.676L3.062,10.169A1.5,1.5,0,0,1,4,7.5H9.753L6.738,2.811A1.5,1.5,0,1,1,9.26,1.188l4.5,7A1.5,1.5,0,0,1,12.5,10.5H8.266l2.28,1.83a1.5,1.5,0,0,1,.323,1.981L8.818,17.5"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
